export default {
  index: [
    {
      path: '/dkbyj',
      component: resolve => require(['./dkbyjIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/dk_byj/_router.js